import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ErrorResponse } from '@/api/handlers/responses';
import type { CatalogImportRecord } from '@/api/models';
import { CatalogImportQueryKeys } from './catalogImportQueryKeys';

/**
 * One import's record (`GET catalog-imports/{id}`): every count and both
 * money sets as they were when it ran. Only an undo changes it, and the undo
 * invalidates every catalog-import key.
 *
 * Unwraps the envelope (rulebook §10): a failed read is the query's `error`,
 * code intact (`IMPORT_NOT_FOUND`, `BRANCH_NOT_ALLOWED`).
 */
export const useCatalogImportQuery = (id: string, enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<CatalogImportRecord, ErrorResponse>({
        queryKey: CatalogImportQueryKeys.detail(id),
        queryFn: async () => {
            const result = await apiClient.catalogImports.getById(id);
            if (!result.success) {
                throw result.error;
            }
            return result.response;
        },
        enabled: enabled && id !== '',
        staleTime: 60_000,
    });
};
